/**
 * THEME_NATIVE postcode zone estimate: compares the entered postcode's leading
 * digit against a merchant-configurable list of "metro" prefixes and shows one
 * of two merchant-editable messages. This is a heuristic, not a live carrier
 * rate — the block's own disclaimer says so, and the messages are configured
 * per METAFIELD_SCHEMA.md/CLAUDE.md rules against hard-coded shipping claims.
 */
class ProductDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.checkButton = this.querySelector('[data-check-button]');
    this.postcodeInput = this.querySelector('[data-postcode-input]');
    this.result = this.querySelector('[data-result]');

    this.checkButton?.addEventListener('click', this.#check);
    this.postcodeInput?.addEventListener('input', this.#clearResult);
  }

  disconnectedCallback() {
    this.checkButton?.removeEventListener('click', this.#check);
    this.postcodeInput?.removeEventListener('input', this.#clearResult);
  }

  #clearResult = () => {
    if (!this.result) return;
    this.result.textContent = '';
    this.result.removeAttribute('data-state');
  };

  #check = () => {
    if (!this.result || !this.postcodeInput) return;

    const postcode = this.postcodeInput.value.trim();

    if (!/^\d{4}$/.test(postcode)) {
      this.result.textContent = this.dataset.invalidMessage ?? '';
      this.result.setAttribute('data-state', 'error');
      return;
    }

    const metroPrefixes = (this.dataset.metroPrefixes ?? '').split(',').filter(Boolean);
    const isMetro = metroPrefixes.includes(postcode.charAt(0));

    this.result.textContent = isMetro
      ? (this.dataset.metroMessage ?? '')
      : (this.dataset.regionalMessage ?? '');
    this.result.removeAttribute('data-state');
  };
}

if (!customElements.get('product-delivery-estimate')) {
  customElements.define('product-delivery-estimate', ProductDeliveryEstimate);
}
